export function Kpi({ label, value, unit, icon: Icon, accent = "#0F172A", testid, sub }) {
  return (
    <div data-testid={testid} className="bg-white border border-slate-200 rounded-md p-5 fade-up">
      <div className="flex items-start justify-between">
        <div className="text-xs uppercase tracking-[0.1em] font-bold text-slate-500">{label}</div>
        {Icon && (
          <div className="h-8 w-8 rounded-md flex items-center justify-center" style={{ background: `${accent}14`, color: accent }}>
            <Icon size={18} weight="duotone" />
          </div>
        )}
      </div>
      <div className="mt-3 flex items-baseline gap-1">
        <span className="font-mono text-3xl font-medium tracking-tight text-slate-900">{value}</span>
        {unit && <span className="text-sm text-slate-400 font-medium">{unit}</span>}
      </div>
      {sub && <div className="text-xs text-slate-400 mt-1">{sub}</div>}
    </div>
  );
}
